module.exports = __webpack_public_path__ + "static/media/logo24.a68f0780.png";